import { authStorage } from 'storages';
import { configs } from 'app/services/AuthService/config';
import { goToAuth } from 'app/services/AuthService/helpers/goToAuth';
import { isInvalidGrant } from 'shared/api';
import { refreshAuthTokenApi } from 'app/services/AuthService/api';
import { AuthenticationError } from 'shared/errors';
import { AuthConfigInterface } from 'app/services/AuthService/AuthConfigInterface';

export type OnRefreshTokensFx = (
  refreshToken: string,
  authConfig: AuthConfigInterface,
) => Promise<void>;

export const onRefreshTokensFx: OnRefreshTokensFx = async (refreshToken, authConfig) => {
  try {
    const { access_token, refresh_token } = await refreshAuthTokenApi({
      grantTypeCode: configs.grantType.refresh,
      clientId: authConfig.clientId,
      refreshToken: refreshToken,
    });

    await authStorage.setJwtAuthParams({
      access: access_token,
      refresh: refresh_token,
    });
  } catch (error) {
    if (isInvalidGrant(error)) await goToAuth(authConfig);

    throw new AuthenticationError('Catch error while try to refresh authorization!');
  }
};
